import React, { createContext, useState } from "react";

const UrlServicesContext = createContext();
const { Provider, Consumer } = UrlServicesContext;

function UrlServicesProvider({ children }) {

  /* ### RUTAS DE IMAGEN PARA NEGOCIOS */ 
  const [urlImgServices] = useState("https://aplios.net/goubi/images/tiendas/");
  const [urlImgServicesProductos] = useState( "https://aplios.net/goubi/images/productos/");
  /* ### RUTAS DE IMAGEN PARA DELIVERY */ 
  const [urlImgServicesDespachador] = useState( "https://aplios.net/goubi/images/despachador/");

   /* ### CONSULTA DE SERVICIOS */ 
  const [urlServices] = useState( "https://registro.goubi.com.ec/servicios/routes/");



  return <Provider value={{ urlServices, urlImgServices, urlImgServicesProductos, urlImgServicesDespachador }}>{children}</Provider>;
}

export {
  UrlServicesProvider,
  Consumer as urlServicesConsumer,
  UrlServicesContext,
};
